import React from "react";
import { fromJS } from "immutable";
import { Provider } from "react-redux";
import { withRouter } from "react-router-dom";

import VotingForm from "shared/components/voting-form";
import GivingButtonV2 from "shared/components/giving-form-v2/App/GivingButtonV2";
import { store } from "shared/store";
import { useListenGivingFormRouter } from "shared/custom-hooks/use-listen-giving-form-router";

const DonationArea = ({
  user,
  entity,
  entity: { microsite_campaign },
  assets: { images, countries },
  hasExternalUrls,
  campaign,
  menu: { giving_button_config },
  location,
}) => {
  const { shouldOpenGivingForm } = useListenGivingFormRouter({ location });

  const trackGiveButtonEvent = () => {
    if (typeof window.EventAnalyticsService != "undefined") {
      window.EventAnalyticsService.addEvent({
        name: "GIVING FORM - GIVE BUTTON",
        component_type: "MenuBar",
        component_subtype: "Complex",
      });
    }
  };

  const defaultCampaign = campaign || microsite_campaign || {};

  if (
    (entity && entity.external_give_link) ||
    (campaign && campaign.external_donation_url)
  ) {
    let give_link = null;
    if (entity && entity.external_give_link) give_link = entity.external_give_link;
    if (campaign && campaign.external_donation_url)
      give_link = campaign.external_donation_url;
    return (
      <div>
        <Provider store={store}>
          <GivingButtonV2
            entityId={entity.id}
            buttonText="Give"
            campaign={campaign}
            fromMenuBar="true"
          />
        </Provider>
      </div>
    );
  }

  if (!(defaultCampaign.status === "active" || defaultCampaign.status === "pending")) {
    return <div style={{ display: "none" }}></div>;
  }

  if (defaultCampaign.camp_type === "votes") {
    return (
      <a
        data-testid="t-MenuBar-Complex--Donatio-a"
        className={`btn-flag m-site-btn-double--mate${
          hasExternalUrls ? " primary-color-background" : ""
        }`}
        href={defaultCampaign.url}
        target="_blank"
        onClick={trackGiveButtonEvent}
        rel="noreferrer">
        <img src={images.like_plus} />
        <span className={hasExternalUrls ? "primary-color-background" : ""}>Vote</span>
      </a>
    );
  }

  if (defaultCampaign.camp_type === "match_votes") {
    const markup = `<a data-testid="t-MenuBar-Complex--Donatio-a-2" class='btn-flag pointer m-site-btn-double--mate--wide ${
      hasExternalUrls ? "primary-color-background" : ""
    }'>
        <img src=${images.like_plus}>
          <span class=${hasExternalUrls ? "primary-color-background" : ""}>
            Give &amp; Vote
          </span>
      </a>`;

    return (
      <VotingForm
        launchLocation="menu bar"
        micrositeCampaign={fromJS(defaultCampaign)}
        markup={markup}
        listenToHashChange={true}
        autoLaunchOn={() => shouldOpenGivingForm}
      />
    );
  }

  return (
    <div className="inline-b">
      <Provider store={store}>
        <GivingButtonV2
          entityId={entity.id}
          buttonText="Give"
          campaign={campaign}
          fromMenuBar="true"
        />
      </Provider>
    </div>
  );
};

export default withRouter(DonationArea);
